import React from 'react';
import {
  Lock,
  LockOpen,
} from '@mui/icons-material';

export default [
  'default',
  'animal',
  'bicycle',
  'bicycleParking',
  'stationBicycle',
  'boat',
  'bus',
  'car',
  'crane',
  'helicopter',
  'motorcycle',
  'offroad',
  'person',
  'pickup',
  'plane',
  'ship',
  'tractor',
  'train',
  'tram',
  'trolleybus',
  'truck',
  'van',
  'scooter',
];

export const lockIconSelector = (locked) => {
  if (locked) {
    return <Lock />;
  }
  return <LockOpen />;
};
